<app-form-field-wrapper
  [label]="label"
  [name]="name"
  [colSize]="colSize"
  [formField]="formField">
  <p-multiSelect
    *ngIf="userStore.asArray() as users"
    (ngModelChange)="onChange($event)"
    [options]="users"
    [(ngModel)]="selection"
    optionLabel="username"
    optionValue="_id"
    dataKey="_id">
    <ng-template let-item pTemplate="item">
      <div class="flex align-items-center gap-2">
        <i class="fas fa-user"></i>
        <div>{{ item.username }}</div>
      </div>
    </ng-template>
  </p-multiSelect>
</app-form-field-wrapper>
